import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel"];

  connect() {
    const buttons = [
      ...this.element.querySelectorAll(".docs-code-tabs-nav button"),
    ];
    buttons.forEach((btn, i) => {
      btn.setAttribute("role", "tab");
      btn.setAttribute("aria-selected", i === 0);
    });
    this.panelTargets.forEach((panel) => {
      panel.setAttribute("role", "tabpanel");
    });

    this.element.addEventListener("keydown", this.handleKeydown);
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.handleKeydown);
  }

  select(event) {
    const buttons = [
      ...this.element.querySelectorAll(".docs-code-tabs-nav button"),
    ];
    const index = buttons.indexOf(event.currentTarget);

    buttons.forEach((btn, i) => {
      btn.classList.toggle("active", i === index);
      btn.setAttribute("aria-selected", i === index);
    });

    this.panelTargets.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }

  handleKeydown = (event) => {
    const buttons = [
      ...this.element.querySelectorAll(".docs-code-tabs-nav button"),
    ];
    const currentIndex = buttons.indexOf(event.target);
    if (currentIndex === -1) return;

    let nextIndex;
    switch (event.key) {
      case "ArrowLeft":
        nextIndex = currentIndex > 0 ? currentIndex - 1 : buttons.length - 1;
        break;
      case "ArrowRight":
        nextIndex = currentIndex < buttons.length - 1 ? currentIndex + 1 : 0;
        break;
      case "Home":
        nextIndex = 0;
        break;
      case "End":
        nextIndex = buttons.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    buttons[nextIndex].focus();
    buttons[nextIndex].click();
  };
}
